import React from 'react';
import PropTypes from 'prop-types';

export default class Input extends React.Component
{
    static propTypes = {
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,

        onBlur: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
    };

    render()
    {
        return <div>
            <label>
                {this.props.label}
                <input className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" value={this.props.value} onChange={this.props.onChange} onBlur={this.props.onBlur} />
            </label>
        </div>;
    }
}
